// E-5 — LiftDiagramPanel: creator-flow bridge between the page's stored
// EngineLift + computed cache and the v2 LiftDiagram (TowerDiagram v1 retired).
// Builds the scene on every render (sceneGraph is pure; computed is a cache
// that is never trusted from storage). Refused outputs render the red-hatched
// refusal markers and NO force overlay — color stays out of the base art.
import { useMemo } from 'react';
import type { LiftDetail, LiftComputed } from '@/types/planData';
import { buildScene } from '@/utils/sceneGraph';
import { LiftDiagram } from './LiftDiagram';
import { SchematicLiftDiagram } from './SchematicLiftDiagram';

export interface LiftDiagramPanelProps {
  lift: LiftDetail;
  computed: LiftComputed;
  width?: number;
  height?: number;
  /** 'schematic' (default, Brian 2026-09-08): fixed-art tower + dimension
   *  callouts, Rigging-Calc convention. 'scaled': legacy true-scale scene. */
  view?: 'schematic' | 'scaled';
}

export function LiftDiagramPanel({ lift, computed, width = 640, height = 640, view = 'schematic' }: LiftDiagramPanelProps) {
  const scene = useMemo(() => buildScene(lift, computed), [lift, computed]);
  return (
    <div className="lift-diagram-panel w-full overflow-x-auto" data-testid="lift-diagram-panel" data-lift-id={lift.id}>
      {view === 'schematic' ? (
        <SchematicLiftDiagram
          lift={lift}
          computed={computed}
          forceOverlay={computed.status === 'ok'}
          width={width}
          height={height}
          className="w-full h-auto max-w-[640px]"
        />
      ) : (
        <LiftDiagram
          lift={lift}
          scene={scene}
          computed={computed}
          forceOverlay={computed.status === 'ok'}
          width={width}
          height={height}
          className="w-full h-auto max-w-[640px]"
        />
      )}
    </div>
  );
}
